import { useEventListener } from './useEventListener'

export const usePrintListeners = (onPrint: (_: boolean) => void) => {
  useEventListener('beforeprint', () => onPrint(true))
  useEventListener('afterprint', () => onPrint(false))
}
